import { render } from "./MobileRequestSubscriptionMagicLinkPage.vue?vue&type=template&id=0f526da9&scoped=true"
import script from "./MobileRequestSubscriptionMagicLinkPage.vue?vue&type=script&lang=js"
export * from "./MobileRequestSubscriptionMagicLinkPage.vue?vue&type=script&lang=js"

import "./MobileRequestSubscriptionMagicLinkPage.vue?vue&type=style&index=0&id=0f526da9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f526da9"]])

export default __exports__